import MomentUtils from '@date-io/moment';
import moment from 'moment';

export class MaterialPickerUtils extends MomentUtils {
    getDatePickerHeaderText(date: moment.Moment) {
        return date.format('DD. MMM');
    }
}
